import React, { useState, useEffect, useContext } from 'react';
import Footer from '../components/Footer';
import { Container } from "react-bootstrap";
import Header2 from "../components/Header2";
import { ProfileContext } from '../context/ProfileContext';

const TermsConditions = () => {
  const { CMS, isLoading } = useContext(ProfileContext)

  console.log(CMS)

  return (
    <div>
      <section className="comm_page_banner privacy_page_banner" style={{ backgroundImage: `url(${require('../Assets/Images/comm_page_bg.png')})` }}>
        <Container>
          <Header2 />
          <h3 className="comm_page_heading">Terms And Conditions</h3>
        </Container>
      </section>

      <div className="comm_page_layout">
        <Container>
          <div className="text_editor_conent_outer">
            {isLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: CMS.termsConditions }} />
            )}
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
